import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import FormContent from '../FormContent/FormContent';
import { Results } from '../Results/Results';
import { Loader } from '../Loader/Loader';
import { DD_MM_YYYY_UI_FORMAT, MONTH, MONTHS } from '../../../timeConstants';

import { FormErrorComponent } from './FormErrorComponent/FormErrorComponent';
import { fetchFormResultsAction } from './ducks';

const getInitialValues = () => ({
  claimDuration: { textField: 'tot einddatum', valueField: 'INSURANCE_END_DATE' },
  unemploymentClaimDuration: { textField: '12 maanden', valueField: 'YEARS_1' },
  paymentLevel: { textField: 'uitkering naar rato', valueField: 'PRO_RATA' },
  waitingPeriod: { textField: '365 dagen', valueField: 'DAYS_365' },
  sumAssured: '500',
  unemploymentSumAssured: '500',
  claimAssessment: { textField: 'beroepsarbeid', valueField: 'OWN_LABOUR' },
  startDate: moment().startOf(MONTH)
    .add(1, MONTHS)
    .format(DD_MM_YYYY_UI_FORMAT),
});

export const FormContainer = () => {
  const dispatch = useDispatch();
  const isFormResult = useSelector((state) => state.formUserInteractionReducer.isFormResult);
  const isErrorMessage = useSelector((state) => state.formUserInteractionReducer.isErrorMessage);
  const isLoading = useSelector((state) => state.formUserInteractionReducer.isLoading);

  return (
    <>
      <FormContent
        onSubmit={(values) => dispatch(fetchFormResultsAction(values))}
        initialValues={getInitialValues()}
      />
      <section className="orv-form-result">
        {isLoading && !isErrorMessage && !isFormResult && <Loader/>}
        {!isErrorMessage && isFormResult && <Results/>}
        {isErrorMessage && <FormErrorComponent/>}
      </section>
    </>
  );
};
